export const ImageConstant = {
  NointernetConnection:
    "https://s3.ap-south-1.amazonaws.com/mvp-be.life99/NoInternetConnection.svg",
};
